import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/tasks/")({
	component: () => {
		return <Navigate to="/admin/tasks/overdue" replace />;
	},
});
